
import React, { useState } from "react";
import { 
  TextField, Button, Box, Typography, Stepper, Step, StepLabel, 
  Paper, useMediaQuery, useTheme, CircularProgress, Alert
} from "@mui/material";
import { useNavigate } from 'react-router-dom';
import { createKitchen } from "../../services/apiService";


const steps = ["البيانات العامة", "الفروع", "الطاولات", "الخزن", "المطابخ"];

const KitchensSetup = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm")); // ✅ دعم الهواتف المحمولة
  const isTablet = useMediaQuery(theme.breakpoints.down("md")); // ✅ دعم الأجهزة اللوحية

  const [kitchenName, setKitchenName] = useState("المطبخ الرئيسي");
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setKitchenName(e.target.value);
  };

  const handleSave = async () => {
    try {
      setLoading(true);
      const response = await createKitchen(kitchenName);
      setSuccessMessage("✅ تم حفظ المطبخ بنجاح! 🎉 سيتم الانتقال الآن لبدء العمل...");
      setError(null);

      setTimeout(() => navigate('/pos'), 2500);
    } catch (err) {
      setError(err.message);
      setSuccessMessage("");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ width: "100%", display: "flex", justifyContent: "center", mt: 5, mb: 5 }}>
      <Paper elevation={4} sx={{ maxWidth: 600, width: "100%", p: 4, borderRadius: 3, boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)" }}>
        
        {/* ✅ تحسين `Stepper` ليكون متجاوبًا */}
        <Stepper activeStep={4} alternativeLabel={!isSmallScreen} sx={{ mb: 4 }}>
          {steps.map((label) => (
            <Step key={label}>
              <StepLabel>{!isTablet ? label : null}</StepLabel>
            </Step>
          ))}
        </Stepper>

        <Typography variant={isSmallScreen ? "h6" : "h5"} sx={{ mb: 3, fontWeight: "bold", textAlign: "center" }}>
          إعداد المطابخ
        </Typography>

        {/* ✅ إدخال اسم المطبخ */}
        <TextField
          label="اسم المطبخ"
          name="name"
          fullWidth
          value={kitchenName}
          onChange={handleChange}
          sx={{ mb: 2 }}
        />

        {/* ✅ تحسين ترتيب الأزرار لتكون متجاوبة */}
        <Box sx={{ display: "flex", flexDirection: isSmallScreen ? "column" : "row", gap: 2, justifyContent: "center", mt: 2 }}>
          <Button 
            variant="contained" 
            color="primary" 
            onClick={handleSave} 
            disabled={loading} 
            fullWidth={isSmallScreen}
          >
            {loading ? <CircularProgress size={20} /> : "التالي"}
          </Button>
        </Box>

        {/* ✅ تحسين رسائل التنبيه */}
        {successMessage && (
          <Alert severity="success" sx={{ mt: 2, textAlign: "center" }}>
            {successMessage}
          </Alert>
        )}

        {error && (
          <Alert severity="error" sx={{ mt: 2, textAlign: "center" }}>
            ❌ {error}
          </Alert>
        )}
      </Paper>
    </Box>
  );
};

export default KitchensSetup;
